// extracted by mini-css-extract-plugin
module.exports = {"Content":"connect_Content__1S3G8"};